import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { ISocialMediaItem } from '../../_shared/models/social-media-links.model';
import { IconComponent } from '../../icon/icon.component';
import { ButtonComponent } from '../../button/button.component';
import { ILogo } from '../../_shared/models/logo.model';
import { IFooterSimple } from '../../_shared/models/footer-simple.model';
import { IFooter } from '../../_shared/models/footer.model';
import { SocialMediaIconService } from '../../_shared/services/social-media-icon.service';
import { ContainerComponent } from '../../container/container.component';

@Component({
    selector: 'sirius-footer-simple',
    imports: [IconComponent, ButtonComponent, ContainerComponent],
    templateUrl: './footer-simple.component.html',
    styleUrl: './footer-simple.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-m-default' }
})
export class FooterSimpleComponent implements OnInit {
    private _socialMediaIconService = inject(SocialMediaIconService);

    @Input({ required: true }) logo!: ILogo;
    @Input({ required: true }) socialMediaLinks!: ISocialMediaItem[];
    @Input({ required: true }) footer!: IFooter;

    config?: IFooterSimple;
    currentYear = new Date().getFullYear();

    ngOnInit(): void {
        if (this.config) {
            this.socialMediaLinks = this.config.socialMediaLinks;
            this.footer = this.config.footer;
        }

        this.getSoMeIcons();
    }

    private getSoMeIcons() {
        this.socialMediaLinks.forEach(
            (x: ISocialMediaItem) => (x.icon = this._socialMediaIconService.getIconName(x.itemType))
        );
    }
}
